import React from 'react';
import PropTypes from 'prop-types';
import { FilterSelect } from '../../novasoldev/filterselect/src';
import FormInputHOC from './FormInputHOC';
import translator from '../../translations/drupalTranslator';

const FilterSelectBox = ({
  className,
  clearable,
  extraProps,
  filteringType,
  id,
  name,
  onChange,
  options,
  placeholder,
  searchable,
  validate,
  value,
}) => {

  const handleChange = (e) => {
    onChange(name, e !== null ? e : '');
    if (validate) {
      validate({[name]: e});
    }
  };

  const xProps = {
    id: id || name,
    name,
    ...extraProps,
  };

  return (
    <FilterSelect
      className={className}
      clearable={clearable}
      filteringType={filteringType}
      noResult={translator.translate('No result found')}
      onChange={(event) => handleChange(event)}
      options={options}
      placeholder={placeholder}
      preSelected={value.toString()}
      searchable={searchable}
      {...xProps}
    />
  );
};

FilterSelectBox.defaultProps = {
  options: [{
    text: 'ERROR - No OPTIONS',
    value: 'ERROR',
  }],
};

FilterSelectBox.propTypes = {
  className: PropTypes.string,
  clearable: PropTypes.bool,
  extraProps: PropTypes.shape({}),
  filteringType: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
  validate: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default FormInputHOC(FilterSelectBox);
